module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921035649_T.c96a7b63.jpg";